import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackHorizontalAltThree16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconStackHorizontalAltThree16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.389 7H2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.889a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5M2.5 6A1.5 1.5 0 0 0 1 7.5v1A1.5 1.5 0 0 0 2.5 10h.889a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5zm11 1h-.889a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.889a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5m-.889-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h.889A1.5 1.5 0 0 0 15 8.5v-1A1.5 1.5 0 0 0 13.5 6zM7.556 7h.889a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.89a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5m-1.5.5a1.5 1.5 0 0 1 1.5-1.5h.889a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-.89a1.5 1.5 0 0 1-1.5-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackHorizontalAltThree16);
